import { createSelector } from 'reselect'
import { RootState } from '@store/index'
import { asDecimal } from '@helpers/utils'

export const ticketFactorSelector = createSelector(
  (state: RootState) => state.shopState.appData.tickets_gross_value,
  tickets_gross_value => asDecimal(tickets_gross_value),
)
